/** Background work waits after completion and yields to interactive work. */
export function startRecoveryPolling(options: {
  run: () => Promise<unknown>;
  isPaused: () => boolean;
  onError: (error: unknown) => void;
  intervalMs?: number;
  runImmediately?: boolean;
}) {
  let disposed = false;
  let timer: ReturnType<typeof setTimeout>;
  const tick = async () => {
    try {
      if (!disposed && !options.isPaused()) await options.run();
    } catch (error) {
      if (!disposed) options.onError(error);
    } finally {
      if (!disposed)
        timer = setTimeout(() => void tick(), options.intervalMs ?? 5 * 60_000);
    }
  };
  if (options.runImmediately === false)
    timer = setTimeout(() => void tick(), options.intervalMs ?? 5 * 60_000);
  else void tick();
  return () => {
    disposed = true;
    clearTimeout(timer);
  };
}
